import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Cart from "../pages/cart/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/carrinho",
    element: <Cart />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
